import { MsalProvider } from '@azure/msal-react';
import { initGA, logPageView, scrollTop, msalInstance } from '@utils';
import {
  Route,
  BrowserRouter as Router,
  Routes,
  useLocation,
} from 'react-router-dom';
import { useEffect } from 'react';
import { DashboardHome, ReportsList, ReportDetail } from './components/pages';
import { DashboardLayout } from '@organisms/DashboardLayout/DashboardLayout';
import { RoutesList } from './routes/Routes';
import { basename } from './routes/basename';
import { InternalServerErrorTemplate, NotFoundErrorTemplate } from '@templates';
import { ProtectedRoute } from './components/ProtectedRoute/ProtectedRoute';
import { PhaseBanner, SignOutLink } from '@molecules/*';

function App() {
  useEffect(() => {
    initGA();
    logPageView();

    const logPageViewOnRouteChange = () => logPageView();
    window.addEventListener('popstate', logPageViewOnRouteChange);

    return () =>
      window.removeEventListener('popstate', logPageViewOnRouteChange);
  }, []);

  return (
    <Router basename={basename}>
      <RouteChangeTracker />
      <Pages />
    </Router>
  );
}

function Pages() {
  const location = useLocation();
  const phaseLabel = 'BETA';
  const phaseContent =
    "This is a new service. You can track the status of all your reports online. We're still setting up email notifications for some report types.";

  useEffect(() => {
    scrollTop();
  }, [location.pathname]);

  return (
    <MsalProvider instance={msalInstance}>
      <DashboardLayout headerAction={<SignOutLink />}>
        <PhaseBanner phase={phaseLabel} content={phaseContent} />
        <Routes>
          <Route element={<ProtectedRoute />}>
            <Route path={RoutesList.HOME} element={<DashboardHome />} />
            <Route path={RoutesList.REPORTS_LIST} element={<ReportsList />} />
            <Route path={RoutesList.REPORT_DETAIL} element={<ReportDetail />} />
          </Route>
          <Route
            path={RoutesList.INTERNAL_SERVER_ERROR}
            element={<InternalServerErrorTemplate />}
          />
          <Route
            path={RoutesList.NOT_FOUND}
            element={<NotFoundErrorTemplate />}
          />
        </Routes>
      </DashboardLayout>
    </MsalProvider>
  );
}

export const RouteChangeTracker = () => {
  const location = useLocation();

  useEffect(() => {
    logPageView();
  }, [location]);

  return null;
};

export default App;
